import { StyledConverter } from "./styled.js";

import Buttons from "../Buttons/index.js";
import Output from "../Output/index.js";
import CurrencyInputArea from "../CurrencyInputArea/index.js";

const Converter = ({
  currencies,
  amountPLN,
  onAmountChange,
  calculatedOutput,
  targetCurrencyCode,
  onCurrencyChange,
  onReset,
  onFormSubmit,
  rates,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    onFormSubmit();
  };
  return (
    <StyledConverter onSubmit={handleSubmit}>
      <CurrencyInputArea
        currencies={currencies}
        amountPLN={amountPLN}
        onAmountChange={onAmountChange}
        targetCurrencyCode={targetCurrencyCode}
        onCurrencyChange={onCurrencyChange}
        rates={rates}
      />
      <Buttons onReset={onReset} />
      <Output
        calculatedOutput={calculatedOutput}
        targetCurrencyCode={targetCurrencyCode}
        currencies={currencies}
      />
    </StyledConverter>
  );
};

export default Converter;
